//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {apiUrl, apiParams} from '@/const/const'
import MyBtnReturn from '@/components/subComponents/MyBtnReturn'

export default {
    name: "ReportContNo",
    components: {
        MyBtnReturn
    },
    data() {
        return {
            ladingId: '',
            src1: require('@/assets/images/plan/wx_zhuang_blue.png'), // 装箱的图片
            src2: require('@/assets/images/plan/wx_chai_oringe.png'), // 拆箱的图片
            tableData: [
                // {
                //   id: 'AD154654',
                //   contNo: 'ajdfkadfjakl',
                //   sealNo: 'ajdfkadfjakl',
                // },
                // {
                //   id: 'AD154654',
                //   contNo: 'ajdfkadfjakl',
                //   sealNo: '',
                // },
            ],
            isTodayEnd: false, // true就代表今日计划的数据获取完了
            isShowTable: true,
            isShowLoading: false,
            isShowConfirm: false,
            canUpdate: true, // true代表能继续发送请求，控制onConfirm方法的
            isNoData: false,
            isDisabledList: [], // 控制btn-report按钮的是否禁用属性，有多个按钮，因此有多个元素
            content: {
                id: '',
                contNo: '',
                sealNo: '',
                shipperW: '',
                index: 0, // 存放该数据的索引，onConfirm中可以找到isDisabledList对应的元素
            },
        }
    },
    created() {
        document.title = '报柜号';
        this.ladingId = this.$route.query.ladingId;
        this.getData()
    },
    methods: {
        getData() {
            // 获取工作单下要报柜号的柜，一个工作单可能有多个柜号id，对应第二个页面
            let data = {
                openId: apiParams.openId,
                companyId: apiParams.companyId,
                code: apiParams.code,
                ladingId: this.ladingId,
            };
            this.isShowLoading = true;
            // 先获取今日计划的数据
            // 调用接口获取数据
            this.requestApi({
                url: apiUrl.getReportContNoSono,
                data: data
            }, (resultData) => {
                this.ladingId = resultData.data.ladingId; // 已经通过路由获得，这行可有可无
                let list = resultData.data.sonos || [];
                if (list.length === 0) {
                    // 如果没有数据，要告知用户
                    this.isNoData = true;
                    this.isShowLoading = false;
                    this.tableData = list;
                    return
                }
                // todo:前端添加两个属性，分别代表是否已报柜号、是否已报封条号
                list.forEach((item) => {
                    // this.tableData.forEach((item) => { // 要注释
                    item.isReportContNo = item.contNo; // 真值就代表已报柜号了
                    item.isReportSealNo = item.sealNo; // 真值就代表已报封条号了
                    // 添加对应数量的禁用属性，如果contNo与sealNo都为真值，那就直接添加true，禁用按钮
                    if (item.contNo && item.sealNo) {
                        this.isDisabledList.push(true)
                    } else {
                        this.isDisabledList.push(false)
                    }
                });
                this.tableData = list;
            }, (error) => {
                this.isShowLoading = false;
                if (error) {
                    console.error(error); // 请求出错时，在这里log比较好，才能立即找到是哪个函数出错
                }
            })
        },
        btnReportFn(index, id) {
            // todo: 现在写的逻辑：只要报过了，就不给修改
            // 按钮btn-report的方法，先检验是否有输入柜号或者封号(至少有一个)，然后弹窗询问用户是否确认报柜号
            let tableData = this.tableData[index];
            let contNo = tableData.contNo && tableData.contNo.toUpperCase();
            let sealNo = tableData.sealNo && tableData.sealNo.toUpperCase();
            let shipperW = tableData.shipperW;
            let isReportContNo = tableData.isReportContNo;
            let isReportSealNo = tableData.isReportSealNo;
            if (!shipperW) {
                this.showToast('货重必填！', 2000, 'warn');
                return;
            }
            if (contNo || sealNo || shipperW) {
                if (isReportContNo && contNo && !sealNo && !shipperW) {
                    // 已经报过柜号了，但这次又不填写封条号，不给继续报
                    this.showToast('已经报过柜号了！', 2000, 'warn');
                    return
                }
                if (isReportSealNo && sealNo && !contNo && !shipperW) {
                    // 已经报过封条号了，但这次又不填写柜号，不给继续报
                    this.showToast('已经报过封条号了！', 2000, 'warn');
                    return
                }
                this.isShowConfirm = true;
                this.content = {
                    id: id,
                    contNo: contNo || '',
                    sealNo: sealNo || '',
                    shipperW: shipperW,
                    index: index, // 该索引可对应tableData与isDisabledList的数据
                }
            } else {
                this.showToast('请输入柜号或封条号', 2000, 'warn')
            }
        },
        onConfirm() {
            // 更新对应 的柜号、封号
            if (!this.canUpdate) return;
            this.canUpdate = false;
            let data = {
                openId: apiParams.openId,
                companyId: apiParams.companyId,
                code: apiParams.code,
                ladingId: this.ladingId,
                id: this.content.id,
                contNos: this.content.contNo,
                sealNos: this.content.sealNo,
                shipperW: this.content.shipperW,
            };
            let index = this.content.index;
            this.$vux.loading.show({
                text: 'Loading'
            });
            this.requestApi({
                url: apiUrl.reportContNo,
                data: data
            }, (resultData) => {
                this.$vux.loading.hide();
                // 到这一步，那就是更新成功了：判断是报了哪个，如果都报了，那就禁用对应的按钮，连柜号的input也要禁用！
                let successInfo = resultData.data.info || '操作成功！';
                // this.showToast('操作成功！', 2000)
                this.showToast(successInfo, 2000);
                if (data.sealNos && data.contNos) {
                    this.isDisabledList[index] = true;
                    this.tableData[index].isReportContNo = true;
                    this.tableData[index].isReportSealNo = true
                } else if (data.contNos) {
                    this.tableData[index].isReportContNo = true
                } else if (data.sealNos) {
                    this.tableData[index].isReportSealNo = true
                }
            }, (error) => {
                this.canUpdate = true;
                this.$vux.loading.hide();
                if (error) {
                    console.error(error); // 请求出错时，在这里log比较好，才能立即找到是哪个函数出错
                }
            })
        },
        changeToUpperCase(item, index) {
            this.tableData[index][item] = this.tableData[index][item] && this.tableData[index][item].toUpperCase(); // 防止数据为null
        }
    },
}



// WEBPACK FOOTER //
// ./src/components/siji/reportContNo/ReportContNo.vue